import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import { getIsShowMainAndrelatedNews } from '../../js/utils';
import './index.scss';

const EventHandler = {
  goMain(node, event) {
    if (window.wv.isMethodValid('BrowserIFlow.jumpToNewsChannel')) {
      window.wv.invoke('BrowserIFlow.jumpToNewsChannel', '6aaW6aG1', '首页');
      if (window.wv.isMethodValid('generalStat')) {
        window.wv.generalStat(20084071, 10012, 21034, JSON.stringify({}));
      }
    }
  },
};

export default class Main {
  constructor(el, name, data = {}) {
    this.el = el;
    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  render() {
    this.el.innerHTML = template({
      isShow: getIsShowMainAndrelatedNews(),
    });
  }
}
